<template>
  <b-modal :active.sync="showModal" :can-cancel="false" :width="700">
    <div class="card">
      <div class="card-content">
        <div class="columns is-mobile is-vcentered">
          <div class="column">
            <p class="title is-3">
              {{ type === 'REGISTER' ? $t('register.title') : $t('login.title') }}
            </p>
          </div>
          <div class="column is-narrow">
            <b-icon icon="clear" class="pointer" @click.native="showModal = false" />
          </div>
        </div>
        <b-loading :is-full-page="false" :active.sync="loading" />
        <div v-if="type === 'LOGIN'" class="messenger-login-benefits">
          {{ $t('messenger.loginBenefits') }}
        </div>
        <form @submit.prevent="submit">
          <b-field
            :label="$t('fields.email')"
            :type="{'is-danger': errors.has('email')}"
            :message="errors.first('email')"
          >
            <b-input
              v-model="model.email"
              v-validate="{
                required: true,
                email: {
                  allow_utf8_local_part: false
                },
                uniqueEmail: type === 'REGISTER'
              }"
              name="email"
              size="is-medium"
            />
          </b-field>

          <b-field
            :label="$t('register.enterPassword')"
            :type="{'is-danger': errors.has('password')}"
            :message="errors.first('password')"
          >
            <b-input
              v-model="model.password"
              v-validate="type === 'REGISTER' ? 'required|min:6' : 'required'"
              name="password"
              type="password"
              password-reveal
              size="is-medium"
            />
          </b-field>

          <b-field
            v-if="type === 'REGISTER'"
            class="m-t-20"
            :type="{'is-danger': errors.has('acceptRegulations')}"
            :message="errors.first('acceptRegulations')"
          >
            <b-checkbox
              v-model="acceptRegulations"
              v-validate="'required:false'"
              name="acceptRegulations"
            >
              <i18n path="checkout.accept_regulations">
                <a @click.prevent="regulationsModal = true">{{ $t('checkout.link') }}</a>
              </i18n>
            </b-checkbox>
          </b-field>

          <div class="form-control m-t-30">
            <button type="submit" class="button is-success is-large is-fullwidth" :disabled="loading || errors.any()">
              {{ type === 'REGISTER' ? $t('register.button_send') : $t('login.button_send') }}
            </button>
          </div>

          <ul class="center m-b-20 m-t-30">
            <template v-if="type === 'REGISTER'">
              <li>
                <a @click.prevent="type = 'LOGIN'">
                  {{ $t('register.login') }}
                </a>
              </li>
            </template>
            <template v-if="type === 'LOGIN'">
              <li>
                <a @click.prevent="type = 'REGISTER'">
                  {{ $t('login.register') }}
                </a>
              </li>
              <li>
                <nuxt-link :to="localePath('auth-forgot-password')">
                  {{ $t('forgotPassword.link') }}
                </nuxt-link>
              </li>
            </template>
          </ul>

          <socials no-redirect @success="successSocialLogin" @loading="x => loading = x" />
        </form>
        <b-modal :active.sync="regulationsModal">
          <div class="card">
            <div class="card-content">
              <full-description :description="regulations" />
            </div>
          </div>
        </b-modal>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Socials from '~/marketplace-front-core/components/auth/Socials'
import loginMixin from '~/marketplace-front-core/mixin/login'
import FullDescription from '~/marketplace-front-core/components/shared/FullDescription'

export default {
  components: { Socials, FullDescription },
  mixins: [loginMixin],
  data () {
    return {
      type: 'REGISTER',
      regulations: '',
      showModal: false,
      acceptRegulations: false,
      regulationsModal: false,
      model: {
        email: '',
        password: '',
        url: this.localePath({ name: 'auth-confirm-email', params: { token: '1' } }).slice(0, -1)
      },
      loading: false
    }
  },
  created () {
    this.$api.cms.url({ url: this._slugRegulations })
      .then((res) => { this.regulations = res.productDescriptionSections })
      .catch(() => { return null })
  },
  methods: {
    open () {
      this.showModal = true
    },
    submit () {
      this.$validator.validate().then((result) => {
        if (result) {
          this.loading = true
          if (this.type === 'REGISTER') {
            this.$api.auth
              .register(false, this.model)
              .then((result) => {
                this.$buefy.toast.open({
                  message: this.$t('register.success'),
                  type: 'is-success'
                })
                this.login()
              })
              .catch(() => {
                this.loading = false
                this.$buefy.toast.open({
                  message: this.$t('register.error'),
                  type: 'is-danger'
                })
              })
          } else if (this.type === 'LOGIN') {
            this.login()
          } else {
            this.loading = false
          }
        } else {
          this.loading = false
        }
      })
    },
    login () {
      this.$api.auth.login({
        username: this.model.email,
        password: this.model.password
      })
        .then((res) => {
          this.successLogin(res, true)
          this.showModal = false
        })
        .catch(() => {
          this.errorLogin()
        })
        .finally(() => {
          this.loading = false
        })
    },
    successSocialLogin () {
      this.showModal = false
    }
  }
}
</script>
